import { render, staticRenderFns } from "./MenuPantallaStore.vue?vue&type=template&id=4395ff0e&scoped=true"
import script from "./MenuPantallaStore.vue?vue&type=script&lang=js"
export * from "./MenuPantallaStore.vue?vue&type=script&lang=js"
import style0 from "./MenuPantallaStore.vue?vue&type=style&index=0&id=4395ff0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395ff0e",
  null
  
)

export default component.exports